import { cx } from '../utils/cx.js';
import styles from './Avatar.module.css';

export type AvatarPresence = 'online' | 'offline';

export type AvatarProps = {
  label: string;
  src?: string | null;
  /** `nav` = header account chip (uses `--wp-nav-avatar-size`). */
  size?: 'nav' | 'sm' | 'md' | 'lg';
  /**
   * Corner status dot. Omit for no indicator.
   * `online` = menthol green; `offline` = muted feldspar.
   */
  presence?: AvatarPresence;
  className?: string;
};

export function Avatar({ label, src, size = 'md', presence, className }: AvatarProps) {
  const trimmedSrc = src?.trim();
  const title =
    presence === 'online' ? `${label} · en ligne` : presence === 'offline' ? `${label} · hors ligne` : label;
  const initials =
    label
      .split(/\s+/)
      .filter(Boolean)
      .slice(0, 2)
      .map((n) => n[0]?.toUpperCase())
      .join('') || '?';

  const face = trimmedSrc ? (
    <span
      className={cx(styles.root, styles[size], styles.imageShell, !presence && className)}
      aria-hidden
      title={presence ? undefined : title}
    >
      <img src={trimmedSrc} alt="" className={styles.image} />
    </span>
  ) : (
    <span
      className={cx(styles.root, styles[size], !presence && className)}
      aria-hidden
      title={presence ? undefined : title}
    >
      {initials}
    </span>
  );

  if (!presence) return face;

  return (
    <span
      className={cx(styles.presenceShell, styles[`presenceShell_${size}`], className)}
      title={title}
    >
      {face}
      <span
        className={cx(
          styles.presenceDot,
          presence === 'online' ? styles.presenceOnline : styles.presenceOffline,
        )}
        aria-hidden
      />
    </span>
  );
}
